<div class="row">
  <div class="col-9 col-md-9 col-sm-12">
    @if (blogPage && blogPage.content.length > 0) {
      <section class="blog-overview">
        @for (blog of blogPage.content; track blog; let i = $index) {
          <article
            [ngClass]="getBlogItemSize(i)"
            class="blog-overview-item"
            >
            <div class="blog-overview-item__image">
              @if (hasValidCmsRelativeUrl(blog.imageItemUrl)) {
                <a
                  [routerLink]="['/blogs/detail', { blogId: blog.blogId }]"
                  >
                  <img
                    height="265"
                    src="{{ getCmsUrl(blog.imageItemUrl) }}"
                    width="470"
                    />
                </a>
              }
            </div>
            <div class="blog-overview-item__text">
              <div class="blog-overview-item__category">
                <span class="">{{ blog.categoryName }}</span>
              </div>
              <h2 class="blog-overview-item__title">
                <a [routerLink]="['/blogs/detail', { blogId: blog.blogId }]">
                  {{ blog.title }}</a
                  >
                </h2>
                <p class="blog-overview-item__intro">
                  {{ blog.description }}
                </p>
                <p class="blog-overview-item__readmore">
                  <a [routerLink]="['/blogs/detail', { blogId: blog.blogId }]">
                    Read more
                    <svg class="icon-arrow-right" height="12" width="7">
                      <use
                        xlink:href="/images/icons/svg-sprite.svg#arrow-right"
                      ></use>
                    </svg>
                  </a>
                </p>
              </div>
            </article>
          }
        </section>
      } @else {
        <article class="cms-article cms-article--blog">
          <p i18n="No blogs available@@no.blogs.available">
          There are currently no blogs available
        </p>
        </article>
      }
    </div>
  </div>
